import React from 'react';
import BaseFilter from './base_filter';
import { FILTER_OPTIONS } from "./filter_constants_and_helpers";
import FilterSelect from '../partners/filter_select';
import { reject } from 'lodash';

const additionalFilterOptions = [
    {id: -1, system_name: "jewelry_brand_other", pretty_name: "Other"},
    {id: -2, system_name: "jewelry_brand_not_branded", pretty_name: "Not Branded"}
];

class WatchesBrandDropdownFilter extends BaseFilter {

    constructor(props) {
        super(props)

        Object.assign(this.state,this.stored || this._defaultValue())

        // get visible options from all options.
        this.options = [...FILTER_OPTIONS.brands, ...additionalFilterOptions]

        this._setDefault = this._setDefault.bind(this)
        this._setFiltersInternal = this._setFiltersInternal.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
    }

    removeFilter(name) {
        if ( name ) {
            this._setFiltersInternal(WatchesBrandDropdownFilter.getFilterName(), this._dropDownRemoveFilter(name, " brand"))
        } else {
            this._setDefault()
        }
    }

    /**
     * The following set of function starting with _ are 'protected' and should be called by the base class only.
     * @private
     */
    _defaultValue() {
        return { in:[], not_in: [], is: [] }
    }

    _setDefault() {
        this.setFilters(WatchesBrandDropdownFilter.getFilterName(), this._defaultValue())
    }

    _setFiltersInternal(filterName,newValue) {
        /*
        *  -1 - Other
        *  -2 - Not Branded
        * */
        const inFilterData = reject(newValue, e => e === -1 || e === -2);

        const newFilterData = {
            in: inFilterData,
            not_in: newValue.includes(-1) ? [-1] : [],
            is: newValue.includes(-2) ? [-2] : []
        };

        this.setFilters(filterName, newFilterData, this.removeFilter);
    }

    _render() {
        return <div><FilterSelect
            label={"Brand"}
            name={WatchesBrandDropdownFilter.getFilterName()}
            options={this.options}
            route={"recent_deals_"+this.props.itemType}
            selectedOptions={[...this.state.in, ...(this.state.not_in ? this.state.not_in : []), ...(this.state.is ? this.state.is : [])]}
            setFilters={this._setFiltersInternal}
            systemName={WatchesBrandDropdownFilter.getFilterName()}
        />
        </div>
    }

    _getFilterValue() {
        return {in:this.state.in, not_in: this.state.not_in, is: this.state.is}
    }

    _getFilterName() {
        return WatchesBrandDropdownFilter.getFilterName()
    }

    _tagName(newState) {
        let tagList = [];
        for ( let id of [ ...newState.in, ...(newState.not_in ? newState.not_in : []), ...(newState.is ? newState.is : []) ] ) {
            tagList.push(this.options.find(e => e.id === id).pretty_name + ' brand')
        }
        return tagList
    }

    _apiKeys() {
        return ['in', 'not_in', 'is']
    }

    /**
     * static functions to be supported without an instance for generic filter usage implementations.
     * @returns {string}
     */
    static getFilterName() {
        return 'watch_brands'
    }
}

export default WatchesBrandDropdownFilter;